import { render } from "./VisitorHealthCheckStatusColumn.vue?vue&type=template&id=39109db2&scoped=true"
import script from "./VisitorHealthCheckStatusColumn.vue?vue&type=script&lang=js"
export * from "./VisitorHealthCheckStatusColumn.vue?vue&type=script&lang=js"

import "./VisitorHealthCheckStatusColumn.vue?vue&type=style&index=0&id=39109db2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39109db2"]])

export default __exports__